import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=bb22fa3a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb22fa3a')) {
      api.createRecord('bb22fa3a', component.options)
    } else {
      api.reload('bb22fa3a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=bb22fa3a&", function () {
      api.rerender('bb22fa3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hpz7ha947wRJ/JS/comp/FavElement.vue"
export default component.exports